<script setup lang="ts">
import { Bar } from 'vue-chartjs'
import { 
  Chart as ChartJS, 
  Title, 
  Tooltip, 
  Legend, 
  BarElement, 
  CategoryScale, 
  LinearScale 
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const chartData = {
  labels: ['Day 1', 'End of Week 1', 'Start of Week 2'],
  datasets: [{
    label: 'Cashflow Casino Model',
    data: [0, 5000, 4250],
    backgroundColor: '#F9D423'
  }, {
    label: 'Traditional Model',
    data: [-10000, -5000, -5750],
    backgroundColor: '#F861A3'
  }]
}

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    tooltip: {
      callbacks: {
        title: (items: any) => items[0].label
      }
    }
  },
  scales: {
    y: {
      ticks: { color: '#A78BFA' },
      grid: { color: 'rgba(167, 139, 250, 0.1)' }
    },
    x: {
      ticks: { color: '#A78BFA' },
      grid: { display: false }
    }
  }
}
</script>

<template>
  <div class="text-[#E0D6F9] font-['Poppins'] p-6 antialiased">
    <main class="container mx-auto">

      <header class="text-center mb-16">
        <h1 class="text-4xl md:text-6xl font-black text-white">
          The Operator's <span class="bg-gradient-to-r from-[#F9D423] to-[#F861A3] bg-clip-text text-transparent">Cash Flow Advantage</span>
        </h1>
      </header>
      
      <section class="grid md:grid-cols-2 gap-8 mb-16">
        <div class="bg-[#281b44]/70 backdrop-blur-xl border border-purple-500/20 p-8 rounded-2xl text-center">
          <h2 class="text-xl font-bold mb-4 text-purple-200">Initial Investment</h2>
          <p class="text-7xl font-black bg-gradient-to-r from-[#F9D423] to-[#F861A3] bg-clip-text text-transparent">$0</p>
          <p class="mt-4 text-purple-300/80">We provide the bank upfront.</p>
        </div>
        <div class="bg-[#281b44]/70 backdrop-blur-xl border border-purple-500/20 p-8 rounded-2xl">
          <h2 class="text-xl font-bold mb-4 text-center text-purple-200">The GGR Formula</h2>
          <div class="flex justify-around items-center text-2xl font-bold text-white">
            <span>Bets</span>
            <span class="text-purple-400">-</span>
            <span>Wins</span>
            <span class="text-purple-400">=</span>
            <span class="bg-gradient-to-r from-[#F9D423] to-[#F861A3] bg-clip-text text-transparent">Profit</span>
          </div>
        </div>
      </section>

      <section class="bg-[#281b44]/70 backdrop-blur-xl border border-purple-500/20 p-8 rounded-2xl mb-16">
        <div class="h-[300px] md:h-[400px]">
          <Bar :data="chartData" :options="chartOptions" />
        </div>
      </section>
    </main>
  </div>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700;900&display=swap');
</style>
